import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { cancelInvoice } from '../features/lotteryInvoice'
import { useDispatch } from 'react-redux';
import { getCredit } from "../features/creditReducer";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
const PreviousBarInvoice = (props) => {
    const navigate = useNavigate()
    const location = useLocation();
    const dispatch = useDispatch()
    const CancelInvoice = async () => {
        const check = window.confirm("คุณแน่ใจนะว่าต้องการคืนโพยหวยนี้ ?");
        if (check) {
            const data = {
                lotteryId: props.data.lotteryId,
                lotteryRound: props.lotteryRound.ticketList[0]?.lotteryRound,
                invoiceId: props.data._id,
            };
            //   console.log("fffff",data)
            let returnData = await dispatch(cancelInvoice(data));
            if (returnData === "999999") {
                dispatch(getCredit())
            }
            setTimeout(() => {
                navigate('/historylottery')
            }, 2000);
        }
    };

    const CancelButton = (props) => {
        const [state, setState] = useState({
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            text: "ปิดคืนโพย",
        });

        useEffect(() => {
            const id = setInterval(() => {
                const currentTime = new Date().getTime();
                const distanceToDate = new Date(props.data.closeSaleDatetime).getTime() - currentTime;
                let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
                let hours = Math.floor(
                    (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                );
                let minutes = Math.floor(
                    (distanceToDate % (1000 * 60 * 60)) / (1000 * 60)
                );
                let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

                if (props.lotteryName == "หวยรัฐบาลไทย" || props.lotteryName == "หวยรัฐบาลไทย SUPER") {
                    if (days < 1 && hours < 1 && minutes < 30) {
                        // console.log('com1',days,hours,minutes,seconds)
                        setState({
                            ...state,
                            days: days,
                            hours: hours,
                            minutes: minutes,
                            seconds: seconds,
                        });
                    } else {
                        // console.log('com2',days,hours,minutes,seconds)
                        setState({ ...state, text: "เปิดคืนโพย" });
                    }
                } else {
                    if (days < 1 && hours < 1 && minutes < 3) {
                        // console.log('com3')
                        setState({
                            ...state,
                            days: days,
                            hours: hours,
                            minutes: minutes,
                            seconds: seconds,
                        });
                    } else {
                        // console.log('com4',days,hours,minutes,seconds)
                        setState({ ...state, text: "เปิดคืนโพย" });
                    }
                }
            }, 1000);
            return () => {
                clearInterval(id);
            };
        }, []);

        return props.data.isCancel == "yes" || state.text == "ปิดคืนโพย" ? (
            <div className="flex justify-between text-base">
                <p
                    className={`${props.data.isCancel == "yes"
                            ? "bg-defaultStatusCancel2"
                            : props.data.isWin == "yes"
                                ? "bg-defaultStatusWin2"
                                : props.data.isWin == "no"
                                    ? "bg-defaultStatusLost2"
                                    : "bg-defaultStatusWatting2"
                        } w-24 text-sm h-auto rounded-full text-center text-white font-bold py-2 mr-1`}
                >
                    {props.data.isCancel == "yes"
                        ? "คืนโพย"
                        : props.data.isWin == "yes"
                            ? "ถูกรางวัล"
                            : props.data.isWin == "no"
                                ? "ไม่ถูกรางวัล"
                                : "รอผล"}
                </p>
            </div>
        ) : (
            <div className="flex justify-between text-base">
                <p
                    className={`${props.data.isCancel == "yes"
                        ? "bg-gray-500"
                        : props.data.isWin == "yes"
                            ? "bg-green-500"
                            : props.data.isWin == "no"
                                ? "bg-red-500"
                                : "bg-orange-400"
                        } w-24 text-sm h-auto rounded-full text-center text-white px-1 py-1 mr-1`}
                >
                    {props.data.isCancel == "yes"
                        ? "คืนโพย"
                        : props.data.isWin == "yes"
                            ? "ถูกรางวัล"
                            : props.data.isWin == "no"
                                ? "ไม่ถูกรางวัล"
                                : "รอผล"}
                </p>
                <button
                    onClick={() => CancelInvoice()}
                    className={`text-center rounded-full font-bold border text-sm w-24`}
                >
                    คืนโพย
                </button>
            </div>
        );
    };

    return (
        <div className="mx-x4">
            <div className="sticky top-13 mt-0 text-base w-auto text-defaultTextColorBar px-2 py-1 h-auto bg-defaultColorBar flex justify-between">
                <button className="mr-4" type="button" onClick={() => navigate(-1)}>
                    <ArrowBackIosIcon />
                </button>
                <div className="uppercase ml-x1rem">{props.name}</div>
                {/* {console.log("location",location)} */}
                {/* {location.pathname == '/invoiceinfomation' ?
                    <CancelButton
                        data={props.data}
                    />
                : <div></div>} */}
                <CancelButton
                    data={props.data}
                />
            </div>
        </div>
    );
};

export default PreviousBarInvoice;